import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { queryClient } from '../../../../../App'
import { isAdmin, isDealer } from '../../../../../services/AccountService'
import { getRequestsTable } from '../../../../../services/NewApiService'
import { PaginationStoreType } from '../../../../../stores/NewPaginationStore'
import { getComp } from '../../../../../utils/utils/DI'
import { RequestTableParamsType } from '../types/new-requests-table.types'

export const useRequestsTableData = (
  paginationStore: PaginationStoreType<RequestTableParamsType>,
) => {
  const mountedRef = useRef(false) // что-бы setSelectedRow не срабатывал на mount
  const {
    page,
    size,
    sort,
    params: {
      statuses,
      dataCheckingStatus,
      dealerIds,
      district,
      equipmentId,
      isExpired,
      reason,
      reasonId,
      reportId,
      territory,
      to,
      installedTo,
      installedFrom,
      isSuspicious,
      authorId,
      SenderGroupIds,
      financialSourceIds,
      phone,
      preferentialCategory,
      priorities,
      namePartial,
      surnamePartial,
      address,
      agreementCheckingStatus,
      senderId,
      source,
      hasDuplicates,
      from,
      fullName,
      locality,
      categories,
      orderId,
      sourceId,
      isDangerous,
    },
    setSelectedRow,
  } = paginationStore
  const defaultStatuses = paginationStore.params['preset.statuses']

  useEffect(() => {
    if (mountedRef.current) {
      setSelectedRow(null, 0)
    } else {
      mountedRef.current = true
    }
  }, [
    statuses,
    dataCheckingStatus,
    dealerIds,
    district,
    equipmentId,
    isExpired,
    reason,
    reasonId,
    reportId,
    territory,
    to,
    installedTo,
    installedFrom,
    isSuspicious,
    authorId,
    SenderGroupIds,
    financialSourceIds,
    phone,
    preferentialCategory,
    priorities,
    namePartial,
    surnamePartial,
    address,
    agreementCheckingStatus,
    senderId,
    source,
    hasDuplicates,
    from,
    fullName,
    locality,
    categories,
    orderId,
    defaultStatuses,
    sourceId,
    isDangerous,
    setSelectedRow,
  ])

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        'requests-table',
        size,
        page,
        sort,
        statuses,
        dataCheckingStatus,
        dealerIds,
        district,
        equipmentId,
        isExpired,
        reason,
        reasonId,
        reportId,
        territory,
        to,
        installedTo,
        installedFrom,
        isSuspicious,
        authorId,
        SenderGroupIds,
        financialSourceIds,
        phone,
        preferentialCategory,
        priorities,
        namePartial,
        surnamePartial,
        address,
        agreementCheckingStatus,
        senderId,
        source,
        hasDuplicates,
        from,
        fullName,
        locality,
        categories,
        orderId,
        defaultStatuses,
        sourceId,
        isDangerous,
      ],
      queryFn: () =>
        getRequestsTable({
          size,
          page,
          sort,
          statuses,
          dataCheckingStatus,
          dealerIds,
          district,
          equipmentId,
          isExpired,
          reason,
          reasonId,
          reportId,
          territory,
          to,
          installedTo,
          installedFrom,
          isSuspicious,
          authorId,
          SenderGroupIds,
          financialSourceIds,
          phone,
          preferentialCategory,
          priorities,
          namePartial,
          surnamePartial,
          address,
          agreementCheckingStatus,
          senderId,
          sourceId,
          source,
          hasDuplicates,
          from,
          fullName,
          locality,
          categories,
          orderId,
          isDangerous,
          'preset.statuses': paginationStore.params['preset.statuses'],
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId && (!!isAdmin() || !!isDealer()),
    },
    queryClient,
  )
}
